export default () => (
  /**
   * Ícone "clipboard" na cor azul.
   * Utilizado nos metadados de camadas externas
   * para a cópia do link de serviço.
   * Caminho: Menu de ações->Dowload e Serviços.
   */
  <svg
    width="14"
    height="19"
    viewBox="0 0 14 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.67576 3.84924H1.97273C0.890909 3.84924 0 4.68831 0 5.70718V16.8348C0 17.8537 0.890909 18.6927 1.97273 18.6927H8.67576C9.75758 18.6927 10.6485 17.8537 10.6485 16.8348V5.70718C10.6485 4.66833 9.75758 3.84924 8.67576 3.84924ZM9.86364 16.8148C9.86364 17.4341 9.33333 17.9336 8.67576 17.9336H1.97273C1.31515 17.9336 0.784849 17.4341 0.784849 16.8148V5.70718C0.784849 5.08787 1.31515 4.58842 1.97273 4.58842H8.67576C9.33333 4.58842 9.86364 5.08787 9.86364 5.70718V16.8148ZM14 2.55068V13.6783C14 14.6972 13.1091 15.5363 12.0273 15.5363C11.8152 15.5363 11.6242 15.3764 11.6242 15.1567C11.6242 14.9369 11.7939 14.7771 12.0273 14.7771C12.6848 14.7771 13.2152 14.2777 13.2152 13.6583V2.55068C13.2152 1.93137 12.6848 1.43193 12.0273 1.43193H5.32424C4.66667 1.43193 4.13636 1.93137 4.13636 2.55068C4.13636 2.75046 3.96667 2.93026 3.73333 2.93026C3.5 2.93026 3.3303 2.77044 3.3303 2.55068C3.35152 1.53182 4.24242 0.692749 5.32424 0.692749H12.0273C13.1091 0.692749 14 1.53182 14 2.55068Z"
      fill="#3C71DD"
    />
  </svg>
);
